<template>
    <div>
        <v-btn icon @click="showConfig">
            <v-icon>mdi-cog-outline</v-icon>
        </v-btn>

        <config-dialog v-if="isMobile"
                       :show-subscription-cancel="!!currentSubscription"
                       @click:cancel-subscription="onSubscriptionCancelClick"
                       ref="config"/>
        <config-drawer v-else
                       :show-subscription-cancel="!!currentSubscription"
                       @click:cancel-subscription="onSubscriptionCancelClick"
                       ref="config"/>

        <cancel-subscription
            v-if="currentSubscription"
            ref="cancelSubscription"
            :subscription="currentSubscription"
            @success="toSelectPlan"
        />

    </div>
</template>

<script>

import ConfigDialog from '@/components/company/ConfigDialog'
import ConfigDrawer from "@/components/company/ConfigDrawer";
import CancelSubscription from "@/components/student/CancelSubscription";

export default {
    components: {
        CancelSubscription,
        ConfigDialog,
        ConfigDrawer,
    },
    methods: {
        showConfig() {
            var vm = this
            vm.$refs.config.show()
        },
        hideConfig() {
            var vm = this
            vm.$refs.config.hide()
        },
        onSubscriptionCancelClick() {
            const vm = this
            vm.hideConfig()
            vm.$refs.cancelSubscription.show()
        },
        toSelectPlan() {
            const vm = this
            vm.$router.replace({name: 'company.select-plan'})
        }
    },
    computed: {
        currentSubscription() {
            const vm = this
            return vm.account
                && vm.account.stripeAccount
                && vm.account.stripeAccount.currentSubscription
        }
    }
}
</script>